module.exports = __webpack_public_path__ + "static/balance-96214c40637cb4c4aa96ef0a3549c9b0.png";